import React, { ReactElement } from 'react'

import { styled } from 'styled-components'

const PlainCardContainer = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 16px 18px 18px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  text-align: left;
`

const CardTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px;
  color: #111827;
`

const PlainCard = ({
  title,
  children,
  ...props
}: {
  title?: string
  children: ReactElement
} & React.ComponentProps<'div'>) => {
  return (
    <PlainCardContainer {...props}>
      {title && <CardTitle>{title}</CardTitle>}
      {children}
    </PlainCardContainer>
  )
}

export default PlainCard
